<ul class="product-list">
  @for (contract of user.contracts; track contract) {
    @if (getCategoryFromProduct(contract.product); as cat) {
      <li
        [class.removed-product]="removedProducts.indexOf(contract.product) !== -1"
        class="d-flex justify-content-between align-items-center">
        <app-badge [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"
        class="me-1 ms-1"></app-badge>
        @if (removedProducts.indexOf(contract.product) === -1) {
          <button (click)="removeProduct(contract.product)"
            class="btn btn-outline-soft-warning"
            style="border-width: 0"
            type="button">
            <fa-icon icon="unlink"></fa-icon>
            Dissocier
          </button>
        }
        @if (removedProducts.indexOf(contract.product) !== -1) {
          <button (click)="reAddProduct(contract.product)"
            class="btn btn-outline-info"
            style="border-width: 0"
            type="button">
            <fa-icon icon="link"></fa-icon>
            Réassocier
          </button>
        }
      </li>
    }
  }
  @for (product of addedProducts; track product; let index = $index) {
    @if (getCategoryFromString(product.product.tag); as cat) {
      <li
        class="d-flex justify-content-between align-items-center">
        <app-badge [label]="{id: 0, textcolor: cat.textcolor, backcolor: cat.backcolor, name: cat.name}"
        class="me-1 ms-1"></app-badge>
        <div>
          <button (click)="removeToAskedProducts(index)"
            class="btn btn-outline-soft-warning"
            style="border-width: 0"
            type="button">
            <fa-icon icon="times-circle"></fa-icon>
            Enlever
          </button>
        </div>
      </li>
    }
  }
  <li ngbTooltip="Aucun logiciel accessible" [disableTooltip]="possibleProducts.length > 0">
    @if (!addProductMode) {
      <button (click)="showNewProduct()" class="btn btn-link"
        [disabled]="possibleProducts.length === 0">
        <fa-icon icon="plus-circle"></fa-icon>
        Ajouter un logiciel
      </button>
    }
    @if (addProductMode) {
      <div>
        <span class="d-flex gap-2">
          <div>
            <button (click)="disableAddProductMode()" class="btn btn-link">
              <fa-icon icon="times"></fa-icon>
            </button>
          </div>
          <div class="flex-grow-1">
            <app-dynamic-form [(form)]="newform" [questions]="questions">
            </app-dynamic-form>
            <div class="d-flex justify-content-end">
              <button class="btn btn-outline-success justify-self-end" type="button" [disabled]="newform.invalid"
                (click)="addToAskedProducts()">
                <fa-icon icon="plus"></fa-icon>
                Confirmer l'ajout
              </button>
            </div>
          </div>
        </span>
      </div>
    }
  </li>
</ul>
